export default "__VITE_ASSET__kbR$qH9h__"